import { z } from 'zod';

/**
 * Validation for image-uid path params. Any uid the gallery surfaces must
 * match this shape. Live media uids look like `wix:42:img-7`; drafts use
 * UUIDs; sales variants use `sales:<uuid>`.
 */
export const IMAGE_UID_RE = /^[A-Za-z0-9_:.-]{1,200}$/;
export const ImageUidSchema = z.string().regex(IMAGE_UID_RE);

/**
 * Per-image, per-workspace state stored in `imageStates/{imageUid}`. Tracks
 * favorited + binned status. The four mutation endpoints all return the
 * full ImageState after the change so the optimistic UI doesn't refetch.
 */
export interface ImageState {
  imageUid: string;
  workspaceId: string;
  favorited: boolean;
  /** ISO 8601 when `favorited` last became true. null when never (or restored). */
  favoritedAt: string | null;
  /** ISO 8601 when binned. null when not in the bin (or restored). */
  binnedAt: string | null;
  /** ISO 8601 — last mutation timestamp. */
  updatedAt: string;
}

export function defaultImageState(imageUid: string, workspaceId: string): ImageState {
  return {
    imageUid,
    workspaceId,
    favorited: false,
    favoritedAt: null,
    binnedAt: null,
    updatedAt: new Date(0).toISOString(),
  };
}
